import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import DiariasListar from '../../components/diarias/listar/tabela';


function DiariasScreen () {
    return (
        <Fragment>
            <Head titulo="Tabela de Diárias concedidas aos servidores do Município de Macuco"/>
            <Header />
            <Container>
                <DiariasListar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default DiariasScreen;